<template>
  <a :href="url" class="help-link" target="_blank">
    <icon v-if="showIcon && !!icon" :name="icon" class="help-icon" />
    <slot></slot>
  </a>
</template>
<script>
import { openHelpPage } from "@/util/urlBuilder";

export default {
  props: {
    page: {
      type: String,
      required: true,
    },
    showIcon: {
      type: Boolean,
      required: false,
      default: true,
    },
    icon: {
      type: String,
      required: false,
      default: "fa-question-circle",
    },
  },
  computed: {
    url: function() {
      return openHelpPage(this.page);
    },
  },
};
</script>
<style lang="scss" scoped>
.help-link {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;

  &:hover {
    text-decoration: none;
  }

  & > .help-icon {
    display: block;
    font-size: 1rem !important;
  }
}
</style>
